import { jsx, Fragment } from 'react/jsx-runtime';
import { Suspense, lazy } from 'react';

const NoSsrBase = /* @__PURE__ */ lazy(() => Promise.resolve({
  default: ({ children }) => /* @__PURE__ */ jsx(Fragment, {
    children
  })
}));
const NoSsr = ({ children }) => /* @__PURE__ */ jsx(Suspense, {
  fallback: null,
  children: /* @__PURE__ */ jsx(NoSsrBase, {
    children
  })
});

export { NoSsr };
//# sourceMappingURL=NoSSR.js.map
